export const FORM_TYPE = Object.freeze({
  text: 'text',
  radio: 'radio',
  checkbox: 'checkbox',
  email: 'email',
  phone: 'tel',
  date: 'date',
  time: 'time',
})
